var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cascading-scale-unit-select',{on:{"change":function($event){return _vm.scope.row.save()}},model:{value:(_vm.scope.row.model),callback:function ($$v) {_vm.$set(_vm.scope.row, "model", $$v)},expression:"scope.row.model"}})}
var staticRenderFns = []

export { render, staticRenderFns }